"use client"

import { useEffect, useState } from "react"
import API from "../services/api"
import "./OffresClient.css"

const OffresClient = () => {
  const [offres, setOffres] = useState([])
  const [selectedOffre, setSelectedOffre] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const fetchOffres = async () => {
    try {
      setIsLoading(true)
      const res = await API.get("/offres")
      setOffres(res.data)
      setIsLoaded(true)
    } catch (error) {
      console.error("Erreur chargement des offres:", error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchOffres()

    // Force a re-render after a short delay to ensure visibility
    const timer = setTimeout(() => {
      setIsLoaded(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="hotel-app5">
      <header className="app-header">
        <a href="/SolutionHotel/Home" className="header-back-link">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 12H5M5 12L12 19M5 12L12 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Retour
        </a>
        <div className="logo-container">
          <img src="/SolutionHotel/images/logo2.png" alt="Hotel Logo" className="logo" />
        </div>
        <div></div> {/* Empty div for flex spacing */}
      </header>

      <main className="app-main">
        <div className="welcome-banner">
          <h1>
            <span>Offres</span> Spéciales
          </h1>
          <p>Découvrez nos offres et promotions exclusives</p>
        </div>

        <div className="content-container">
          {isLoading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Chargement des offres...</p>
            </div>
          ) : offres.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🔍</div>
              <h3>Aucune offre disponible</h3>
              <p>Revenez bientôt pour découvrir nos prochaines offres</p>
            </div>
          ) : selectedOffre ? (
            <div className="offre-detail-view">
              <button className="back-to-list" onClick={() => setSelectedOffre(null)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19 12H5M5 12L12 19M5 12L12 5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Retour à la liste
              </button>

              <div className="offre-detail-content">
                <div className="offre-detail-image-container">
                  <img
                    src={selectedOffre.image || "/placeholder.svg"}
                    alt={selectedOffre.title}
                    className="offre-detail-image"
                    onError={(e) => {
                      e.target.src = `/placeholder.svg?height=300&width=500&text=${selectedOffre.title}`
                    }}
                  />
                </div>

                <div className="offre-detail-info">
                  <h2 className="offre-detail-name">{selectedOffre.title}</h2>
                  <div className="offre-detail-description">
                    <p>{selectedOffre.description || "Pas de description disponible."}</p>
                  </div>

                  <div className="offre-details-full">
                    <div className="offre-detail-item">
                      <span className="detail-label">Remise:</span>
                      <span className="detail-value">{selectedOffre.discountPercentage}%</span>
                    </div>
                    <div className="offre-detail-item">
                      <span className="detail-label">Validité:</span>
                      <span className="detail-value">
                        {new Date(selectedOffre.startDate).toLocaleDateString("fr-FR")} –{" "}
                        {new Date(selectedOffre.endDate).toLocaleDateString("fr-FR")}
                      </span>
                    </div>
                    <div className="offre-detail-item">
                      <span className="detail-label">Statut:</span>
                      <span className="detail-value">{selectedOffre.active ? "✅ Active" : "❌ Inactive"}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={`content-grid ${isLoaded ? "loaded" : ""}`}>
              {offres.map((offre, index) => (
                <div
                  key={offre._id}
                  className="content-item"
                  style={{ animationDelay: `${index * 0.05}s` }}
                  onClick={() => setSelectedOffre(offre)}
                >
                  <div className="content-item-image">
                    <img
                      src={offre.image || "/placeholder.svg"}
                      alt={offre.title}
                      onError={(e) => {
                        e.target.src = `/placeholder.svg?height=120&width=300&text=${offre.title}`
                      }}
                    />
                    <div className="content-item-overlay">
                      <span className="view-details">Voir détails</span>
                    </div>
                  </div>
                  <div className="content-item-content">
                    <h3>{offre.title}</h3>
                    <div className="content-item-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 4L20 12L12 20M4 12H20"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

     
      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Contact</h4>
            <p>+216 00 000 000</p>
            <p>info@hoteltunis.com</p>
          </div>
          <div className="footer-section">
            <h4>Adresse</h4>
            <p>Avenue de la Promenade</p>
            <p>Tunis, Tunisie</p>
          </div>
          <div className="footer-section">
            <h4>Réservations</h4>
            <p>+216 00 000 000</p>
            <p>reservations@hoteltunis.com</p>
          </div>
          <div className="footer-section">
            <h4>Wi-Fi</h4>
            <p>Réseau: HOTEL_GUEST</p>
            <p>Mot de passe: Disponible à la réception</p>
          </div>
          <div className="footer-section">
            <h4>Suivez-nous</h4>
            <div className="social-links">
              <a href="#" aria-label="Facebook">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="#" aria-label="Instagram">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a href="#" aria-label="Twitter">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>
            © {new Date().getFullYear()} Hotel Tunis. Tous droits réservés.
            <br />
            Créé par{" "}
            <a href="https://www.itbafa.com" target="_blank" rel="noopener noreferrer">
              <img
                src="/SolutionHotel/images/itbafa_logo_white.png"
                alt="ITBAFA Logo"
                style={{ height: "20px", verticalAlign: "middle", marginLeft: "5px" }}
              />
            </a>
          </p>
        </div>
      </footer>
    </div>
  )
}

export default OffresClient
